import { j as i } from "./index.es9.js";
import { composeClassNames as l } from "./index.es88.js";
const c = ({
  children: s = null,
  state: a = "info",
  hasNoIcon: o = !1,
  ...e
}) => /* @__PURE__ */ i.jsxs(
  "div",
  {
    ...e,
    className: l("bl-validation", `bl-validation--${a}`),
    "aria-live": "polite",
    children: [
      !o && /* @__PURE__ */ i.jsx("i", { className: l(`bl-icon--${a}`, "bl-validation__icon") }),
      s
    ]
  }
);
export {
  c as default
};
//# sourceMappingURL=index.es89.js.map
